module.exports = __webpack_public_path__ + "static/assets/118fdf9c666fbb2471b890e059b82b2c.png";